/**
 * Pull a human-readable message out of a failed fetch Response.
 *
 * FastAPI returns errors as { detail: "..." }, or { detail: { message: "..." } }
 * for the structured subscription errors. Without this, a useful 429 — "this
 * invoice was recently sent, wait 47 seconds" — reaches the user as a bare
 * status code, or in the bulk-send path as nothing at all.
 *
 * Always resolves to a string; never throws.
 */
export async function errorDetail(res, fallback = "Something went wrong.") {
  try {
    const data = await res.json();
    const detail = data?.detail;
    if (typeof detail === "string" && detail.trim()) return detail;
    if (typeof detail?.message === "string" && detail.message.trim()) return detail.message;
  } catch {
    // Body wasn't JSON — a proxy error page, or an empty 502. Use the fallback.
  }
  return `${fallback} (HTTP ${res.status})`;
}
